module.exports = __webpack_public_path__ + "media/images/icon__live-7b78a9ca65db77b6b6e9002f12fc54ee.png";